import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../components/AuthProvider';
import { LayoutContext } from '../components/LayoutProvider';
import { useNavigate } from "react-router-dom";
import NeumorphicContainer from './NeumorphicContainer';
import logoicon from '../images/tuutuum-logo-icon.png';
import EmergencyContactsModal from './EmergencyContactsModal';

const RegisterQrCodeStep4 = ({ selectedBearerId, onPrevious }) => {
    const { t } = useTranslation();
    const { setIsHeaderVisible } = React.useContext(LayoutContext);
    const { loginToken } = React.useContext(AuthContext);
    const [showEmergencyContactsModal, setShowEmergencyContactsModal] = useState(true);

    useEffect(() => {
        setIsHeaderVisible(false);

        return () => setIsHeaderVisible(true);
    }, [setIsHeaderVisible]);

    const navigate = useNavigate();

    const handlePrevious = async () => {
        console.log("Handle previous!");
        onPrevious();
    };

    const handleNext = async () => {
        // Clear login state in both localStorage and React state
        localStorage.removeItem('login-token');
        localStorage.removeItem('login-user-id');
        localStorage.removeItem('login-user-type');
        localStorage.removeItem('login-user-name');
        
        // Hard navigate to start page to ensure clean state
        window.location.href = '/';
    };

    return (
        <>
        <NeumorphicContainer>
            <img src={logoicon} alt="Tuutuum Logo" className="block h-7 w-auto" />
            <h2 className="text-center text-2xl leading-tight px-3">
                {t("please_scan_qr_code")}
            </h2>
            {/* Buttons */}
            <div className="flex flex-nowrap w-full gap-4 justify-between">
                {/* Uncomment if you want to enable the previous button */}
                {/* 
                <button
                    className="btn-secondary btn-secondary:hover text-white px-3 py-1 w-auto rounded-md sm:leading-6 text-center font-semibold text-sm transition ease-in-out hover:scale-105"
                    onClick={handlePrevious}
                >
                    {t("previous")}
                </button>
                */}
                <button
                    className="btn-main btn-main:hover text-white px-3 py-1 w-auto rounded-md sm:leading-6 text-center font-semibold text-sm transition ease-in-out hover:scale-105"
                    onClick={handleNext}
                >
                    {t("done")}
                </button>
            </div>
        </NeumorphicContainer>

        {/* Emergency Contacts Modal */}
        {showEmergencyContactsModal && (
            <EmergencyContactsModal
                loginToken={loginToken}
                bearerId={selectedBearerId}
                onClose={() => {
                    setShowEmergencyContactsModal(false);
                    handleNext();
                }}
                onContactAdded={() => {
                    // Optional: Could show a message
                }}
            />
        )}
        </>
    );
}

export default RegisterQrCodeStep4;